import ApplicationController from './application_controller';
import { DateTime } from 'luxon';

export default class extends ApplicationController {
  static targets = [
    'newEventForm',
    'selectLocalStartsAtString',
    'selectLocalEndsAtString',
    'selectLocalStartsOnString',
    'selectLocalEndsOnString'
  ]

  changeLocalStartsAtString(e) {
    const currentVal = DateTime.fromISO(e.currentTarget.value);
    this.selectLocalEndsAtStringTarget.value = currentVal.plus({ hours: 1 }).toLocaleString(DateTime.TIME_24_SIMPLE);
  }

  changeLocalStartsOnString(e) {
    const currentVal = e.currentTarget.value;
    this.selectLocalEndsOnStringTarget.value = currentVal;
  }

  changeLocalEndsOnString(e) {}
}